module.exports = __webpack_public_path__ + "img/close_24px.36cb1612.svg";